import React, { createContext, useContext, useRef } from "react";
import useWebSocket from "../../hooks/useWebSocket";
import GlobalVisio from "../GlobalVisio";

export const WebSocketContext = createContext({
  wsRef: { current: null },
  sendTypingStatus: () => {},
  addCallListener: () => {},
  hangupCall: () => {},
  sendCallRequest: () =>{},
});
export const useWS = () => useContext(WebSocketContext);

export default function UseWebSocket({ children }) {
  const wsRef = useRef(null);
  const { modal, sendTypingStatus, addCallListener, hangupCall,sendCallAccept,sendCallRequest } = useWebSocket(wsRef);

  return (
    <WebSocketContext.Provider value={{ wsRef, sendTypingStatus, addCallListener, hangupCall,sendCallAccept,sendCallRequest }}>
      {children}
      {modal}
      <GlobalVisio wsRef={wsRef} addCallListener={addCallListener} hangupCall={hangupCall} sendCallAccept={sendCallAccept} sendCallRequest={sendCallRequest} />
    </WebSocketContext.Provider>
  );
}
